<template>
  <div class="park-detail">
    <!-- <div class="park-detail-title">
      <div class="park-detail-title-text">{{ landDetailData.name }}</div>
      <div class="park-detail-title-browse-count">
        浏览：{{ landDetailData.statistical }}
      </div>
    </div> -->
    <div class="park-detail-base">
      <div class="park-detail-base-img">
        <div class="swiper mySwiper2">
          <div class="swiper-wrapper">
            <el-image
              v-for="(item, index) in landFileInfo.pronounceImages"
              :src="imgUrl + item.filePath"
              :key="index"
              @click="handleLook(landFileInfo.pronounceImages, index)"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
        </div>
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <el-image
              v-for="(item, index) in landFileInfo.pronounceImages"
              :src="imgUrl + item.filePath"
              :key="index"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
          <div class="swiper-button-prev m-swiper-button" />
          <div class="swiper-button-next m-swiper-button" />
        </div>
      </div>
      <div class="park-detail-base-content">
        <div class="park-detail-base-content-price">
          <div class="park-detail-base-content-price-text">
            {{ landDetailData.name }}
          </div>
          <div
            class="park-detail-base-content-price-span"
            v-show="!landDetailData.parkCode"
          >
            浏览：{{ landDetailData.statistical }}
          </div>
          <div
            class="park-detail-base-content-price-img"
            v-show="landDetailData.parkCode"
            @click="panorama"
          >
            <div>
              <img src="../../assets/images/common/panorama.png" alt="" />
            </div>
            <div>全景图</div>
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">联系人</div>
          <div
            class="park-detail-base-content-info-value info-value-text1 info-value-bold"
          >
            {{ landDetailData.person }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">联系方式</div>
          <div
            class="park-detail-base-content-info-value info-value-text1 info-value-bold"
          >
            {{ landDetailData.phone }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">出让年限</div>
          <div class="park-detail-base-content-info-value info-value-text2">
            {{ landDetailData.transferDate ?? "50" }}年
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">用地面积</div>
          <div class="park-detail-base-content-info-value info-value-text2">
            {{ landDetailData.area }}亩
          </div>
        </div>
        <div class="park-detail-base-content-info grid-single-line">
          <div class="park-detail-base-content-info-key">土地坐落</div>
          <div class="park-detail-base-content-info-value info-value-text3">
            {{ landDetailData.location }}
          </div>
        </div>
        <div
          class="park-detail-base-content-info grid-single-line"
          v-show="landDetailData.parkCode"
          @click="goPark(landDetailData.parkId)"
        >
          <div class="park-detail-base-content-info-key">所属园区</div>
          <div
            class="park-detail-base-content-info-value info-value-text3 flex-box"
          >
            <div>{{ landDetailData.parkName }}</div>
            <div class="into-park">
              <img src="../../assets/images/common/into.png" alt="" />
              进入园区
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="other-box-l-li1">
      <div class="other-box-l-li-text">周边企业</div>
      <div class="other-box-l-li-box">
        <div
          class="other-box-l-li-box-li1"
          v-for="(item, index) in enterpriseList"
          :key="index"
        >
          <div class="other-box-l-li-box-li-l">
            <i class="iconfont icon-ico_arrowright iconfont-color"></i>
          </div>
          <div class="other-box-l-li-box-li-r">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="other-box-l-li1">
      <div class="other-box-l-li-text">基础设施</div>
      <div class="other-box-r-box">
        <div
          class="other-box-r-box-li"
          v-for="(item, index) in infrastructureArr"
          :key="index"
        >
          <div class="other-box-r-box-li-t">
            <img :src="item.img" alt="" />
          </div>
          <div class="other-box-r-box-li-b">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="park-detail-info">
      <div class="park-detail-info-content">
        <div id="landInfo" class="park-detail-info-park">
          <div class="park-detail-info-park-content">
            <table border="1" class="park-detail-table">
              <tr>
                <td colspan="4" class="park-detail-table-header">基本信息</td>
              </tr>
              <tr>
                <td class="park-detail-table-key">地块类型</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.statusName }}
                </td>
                <td class="park-detail-table-key">土地坐落</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.location }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">宗地编号</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.code }}
                </td>
                <td class="park-detail-table-key">土地等级</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.landLevelName }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">用地面积</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.area }}亩
                </td>
                <td class="park-detail-table-key">出让年限</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.transferDate }}年
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">用地状态</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.cleanLand == 1 ? "净地" : "非净地" }}
                </td>
                <td class="park-detail-table-key">行政区划</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.countyName }}
                </td>
              </tr>
              <tr>
                <td colspan="4" class="park-detail-table-header">规划条件</td>
              </tr>
              <tr>
                <td class="park-detail-table-key">容积率</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.plotRate }}
                </td>
                <td class="park-detail-table-key">绿化率</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.greeningRate }}％
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">建筑密度</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.buildingDensity }}％
                </td>
                <td class="park-detail-table-key">建筑限高</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.buildingHeight }}米
                </td>
              </tr>
              <tr>
                <td colspan="4" class="park-detail-table-header">
                  地块招商信息
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">项目名称</td>
                <td colspan="3" class="park-detail-table-value">
                  {{ landDetailData.name }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">土地用途</td>
                <td colspan="3" class="park-detail-table-value">
                  {{ landDetailData.typeName }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">行业分类</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.industryTypeName }}
                </td>
                <td class="park-detail-table-key">用地联系人</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.person }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">参考价格</td>
                <td class="park-detail-table-value">
                  {{
                    landDetailData.price
                      ? landDetailData.price + "万元"
                      : "暂无数据"
                  }}
                </td>
                <td class="park-detail-table-key">联系方式</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.phone }}
                </td>
              </tr>
            </table>
            <div
              v-if="landFileInfo.pronounceVideos?.length"
              class="park-detail-info-investment-video"
            >
              <div
                v-for="(item, index) in landFileInfo.pronounceVideos"
                :key="index"
                class="park-detail-info-investment-video-item"
                @click="playVideos(item)"
              >
                <div class="park-detail-info-investment-video-item-thumbnail">
                  <el-image
                    :src="imgUrl + item.thumbnail"
                    fit="cover"
                    class="park-detail-info-investment-video-item-thumbnail-img"
                  />
                  <el-image
                    :src="require('@/assets/images/common/视频播放.png')"
                    fit="cover"
                    class="park-detail-info-investment-video-item-thumbnail-action"
                  />
                </div>
                <div class="park-detail-info-investment-video-item-title">
                  {{ item.fileTitle }}
                </div>
              </div>
            </div>
            <div
              v-if="landFileInfo.pronounceImages?.length"
              class="park-detail-info-investment-image"
            >
              <div
                v-for="(item, index) of landFileInfo.pronounceImages"
                class="park-detail-info-investment-image-item"
                :key="index"
                @click="handleLook(landFileInfo.pronounceImages, index)"
              >
                <el-image
                  :src="imgUrl + item.filePath"
                  fit="cover"
                  class="park-detail-info-investment-image-item-img"
                />
                <div class="park-detail-info-investment-image-item-title">
                  {{ item.fileTitle }}
                </div>
              </div>
            </div>
            <div
              v-if="landFileInfo.pronounceFiles?.length"
              class="park-detail-info-investment-file"
            >
              <div
                class="park-detail-info-investment-file-li"
                v-for="(item, index) of landFileInfo.pronounceFiles"
                :key="index"
                @click="previewOrDownFile(item.filePath)"
              >
                <div><img :src="getFileIconUrl(item.suffix)" alt="" /></div>
                <div class="park-detail-info-investment-image-item-title">
                  {{ item.fileTitle }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <land-place
        id="landPlace"
        :info="fileShp"
        :detail="{ name: landDetailData.name, id: landDetailData.id }"
        v-if="landDetailData.name"
      />
      <!-- <land-popular-push /> -->

      <video-dialog
        :visible="playVideo.show"
        :videoSrc="playVideo.src"
        :videoTitle="playVideo.title"
        @onCloseVideo="playVideo.show = false"
      />
      <el-image-viewer
        v-if="previewImage.show"
        :url-list="previewImage.urlList"
        :initial-index="previewImage.index"
        :on-close="() => (previewImage.show = false)"
        style="z-index: 9999"
      />
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min";
import "swiper/swiper-bundle.min.css";
import VideoDialog from "@/components/currency/videoDialog";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import LandPlace from "@/views/land/components/LandPlace";
import LandPopularPush from "@/views/land/components/LandPopularPush";
import { getLandInfoTwo, getPicture, getShp } from "@/api/setting/investment";
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/15 16:38
 * @Description 地块详情
 */
export default {
  name: "LandDetail",
  components: { LandPopularPush, LandPlace, ElImageViewer, VideoDialog },
  data() {
    return {
      landDetailData: {}, //详情信息
      landFileInfo: {}, //文件信息
      fileShp: {}, //图形数据
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      playVideo: {
        show: false,
        src: undefined,
        title: undefined,
      },
      previewImage: {
        show: false,
        urlList: [],
        index: 0,
      },
      enterpriseList: [
        { name: "云南临沧鑫圆主业股份有限公司" },
        { name: "云南祥丰实业集团有限公司" },
        { name: "昆明集团股份有限公司" },
        { name: "昆明闻泰通讯有限公司" },
        { name: "云南碧桂园房地产开发有限公司" },
        { name: "昆明明超电缆有限公司" },
        { name: "云南临沧鑫圆主业股份有限公司" },
        { name: "云南祥丰实业集团有限公司" },
        { name: "云南祥丰实业集团有限公司" },
      ],
      infrastructureArr: [
        { name: "土地平整", img: require("@/assets/images/common/land.png") },
        { name: "道路", img: require("@/assets/images/common/road.png") },
        { name: "给水", img: require("@/assets/images/common/water.png") },
        { name: "雨水", img: require("@/assets/images/common/rain.png") },
        { name: "污水", img: require("@/assets/images/common/sewage.png") },
        {
          name: "天然气",
          img: require("@/assets/images/common/natural_gas.png"),
        },
        { name: "供电", img: require("@/assets/images/common/power.png") },
        {
          name: "宽带",
          img: require("@/assets/images/common/broadband.png"),
        },
        {
          name: "通讯",
          img: require("@/assets/images/common/communication.png"),
        },
      ], //基础设施
    };
  },
  created() {
    //this.landDetailData = JSON.parse(sessionStorage.getItem(this.$route.name));
  },
  mounted() {
    let id = this.$route.query.id;
    this.getDetail(id);
    this.getPictureInfo(id);
    this.getShpInfo(id);
    this.$nextTick(() => {
      this.setSwiper();
    });
  },
  methods: {
    getShpInfo(id) {
      getShp(id).then((res) => {
        if (res.data.success) {
          this.fileShp = res.data.data;
        }
      });
    },
    getPictureInfo(id) {
      getPicture(id).then((res) => {
        if (res.data.success) {
          this.landFileInfo = res.data.data;
        }
      });
    },
    getDetail(id) {
      getLandInfoTwo(id)
        .then((res) => {
          if (res.data.success) {
            this.landDetailData = res.data.data;
            // if (!this.landDetailData.pronouncePolygons) {
            //   this.$message.warning("没有提交shp数据");
            // }
          }
        })
        .finally(() => {
          this.mapLoading = false;
        });
    },
    getFileIconUrl(fileSuffix) {
      let iconUrl;
      switch (fileSuffix) {
        case "pdf":
          iconUrl = require("@/assets/images/common/文件-pdf.png");
          break;
        case "doc":
        case "docx":
          iconUrl = require("@/assets/images/common/文件-word.png");
          break;
        case "zip":
        case "rar":
          iconUrl = require("@/assets/images/common/文件-压缩包.png");
          break;
        case "xls":
        case "xlsx":
          iconUrl = require("@/assets/images/common/excel.png");
          break;
        default:
          iconUrl = require("@/assets/images/common/文件-其它.jpg");
      }
      return iconUrl;
    },
    setSwiper() {
      let swiper = new Swiper(".mySwiper", {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      let swiper2 = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
        thumbs: {
          swiper: swiper,
        },
      });
    },
    scrollView(selector) {
      document.querySelector(selector).scrollIntoView();
    },
    previewOrDownFile(url) {
      window.open(this.imgUrl + url);
    },
    goPark(id) {
      this.$router.push({ path: "/parkDetail", query: { id: id } });
    },

    //查看全景
    panorama() {
      window.open("https://720yun.com/vr/09127ua6c16");
    },
    //播放视频
    playVideos(file) {
      this.playVideo.show = true;
      this.playVideo.src =
        systemConfig.imgServer + systemConfig.imgApi + file.filePath;
      this.playVideo.title = file.fileTitle || "";
    },
    //查看图片
    handleLook(list, index) {
      this.previewImage.urlList = [];
      list.forEach((item) => {
        this.previewImage.urlList.push(this.imgUrl + item.filePath);
      });
      this.previewImage.index = index;
      this.previewImage.show = true;
    },
  },
};
</script>

<style scoped>
.park-detail {
  padding: 10px;
  width: calc(60% - 20px);
  margin: 0 auto 10px;
  background: white;
}

.park-detail-title {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #e0e0e0;
  padding: 4px 2px 4px 0;
}

.park-detail-title-text {
  font-size: 1rem;
  font-weight: 600;
  flex-grow: 1;
}

.park-detail-title-browse-count {
  font-size: 0.75rem;
  color: #8a8a8a;
  align-self: flex-end;
  flex-shrink: 0;
}

.park-detail-base {
  display: flex;
  column-gap: 20px;
}

.park-detail-base-img {
  width: 50%;
  height: 300px;
}

.park-detail-base-content {
  width: 50%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px 10px;
  font-size: 0.85rem;
}

.park-detail-base-content-price {
  grid-column: 1 / -1;
  padding: 8px 4px;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.park-detail-base-content-price-text {
  font-weight: bold;
  font-size: 1rem;
  color: #0054bb;
}
.park-detail-base-content-price-span {
  font-size: 0.75rem;
  color: #837a7a;
}
.park-detail-base-content-price-img {
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #0054bb;
  font-size: 0.8rem;
  cursor: pointer;
}
.park-detail-base-content-info {
}

.park-detail-base-content-info-key {
}

.park-detail-base-content-info-value {
}

.info-value-bold {
  font-weight: bold;
}

.info-value-text1 {
  color: #0064fd;
}

.info-value-text2 {
  color: #317dfc;
  font-size: 0.75rem;
}

.info-value-text3 {
  color: #717171;
}

.flex-box {
  display: flex;
}
.into-park {
  /* width: 100px; */
  padding: 2px 10px;
  margin-left: 10px;
  background: #c2f0cf;
  border-radius: 10px;
  color: #00b147;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.grid-single-line {
  grid-column: 1 / -1;
}

.park-detail-info {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  column-gap: 20px;
}

.park-detail-info-content-nav {
  display: grid;
  grid-template-columns: repeat(3, 1fr) 2fr;
  background-color: #f4f4f4;
  padding: 2px;
  cursor: pointer;
}

.park-detail-info-content-nav-item {
}

.park-detail-info-sub-title {
  margin-top: 20px;
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}

.park-detail-info-content {
}

.park-detail-info-investment-content > div {
  border: solid 1px #e0e0e0;
}

.park-detail-info-investment-video {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-video-item-thumbnail {
  width: 120px;
  height: 80px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.park-detail-info-investment-video-item-thumbnail-img {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
}

.park-detail-info-investment-video-item-thumbnail-action {
  grid-column: 2 / 3;
  grid-row: 2 /3;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  color: white;
}

.park-detail-info-investment-video-item-title {
}

.park-detail-info-investment-image {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-image-item-img {
  width: 120px;
  height: 80px;
}

.park-detail-info-investment-image-item-title {
}

.park-detail-info-investment-file {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  border: solid 1px #e5e5e5;
}

.park-detail-info-investment-file-item-img {
  width: 120px;
  height: 80px;
  padding: 8px 28px;
  box-sizing: border-box;
  filter: grayscale(1);
}

table {
  border: solid 1px #d0d0d0;
  border-spacing: 0;
  border-collapse: collapse;
}

.park-detail-table {
  width: 100%;
  text-align: center;
}

.park-detail-table-header {
  background-color: #e6efff;
  color: #105ab5;
  font-weight: 600;
  font-size: 1rem;
  padding: 12px;
}

.park-detail-table-key {
  width: calc(100% / 6);
  padding: 8px;
  color: #000000;
}

.park-detail-table-value {
  color: #858585;
  width: calc(100% / 6 * 2);
  padding: 8px;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 1.12rem;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  height: calc(100% / 7 * 5);
  width: 100%;
}

.mySwiper {
  height: calc(100% / 7 * 2);
  box-sizing: border-box;
  padding: 5px 0;
}

.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.m-swiper-button {
  --swiper-navigation-size: 14px;
  color: white;
  background-color: #00000073;
  width: 20px;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
}

.park-detail-info-investment-file-li {
  width: 120px;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
}
>>> .tz-toggle-layout__warp {
  z-index: 1000 !important;
}

.other-box-l-li1 {
  margin-top: 20px;
  width: 100%;
}
.other-box-l-li2 {
  margin-top: 20px;
  width: 100%;
  display: flex;
}
.other-box-l-li-text {
  width: 200px;
  color: #495eb8;
  font-weight: 600;
  font-size: 0.85rem;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  padding: 5px 10px;
}
.other-box-l-li-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 10px 0 0 0;
}
.other-box-l-li-box-li {
  width: 48%;
  line-height: 30px;
  display: flex;
}
.other-box-l-li-box-li1 {
  width: 23%;
  line-height: 30px;
  display: flex;
}
.other-box-l-li-box-li-r {
  font-size: 0.85rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.other-box-r-box {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  /* grid-template-columns: 30% 30% 30%;
  grid-template-rows: 85px 85px 85px; */
}
.other-box-r-box-li {
  display: flex;
  width: 11%;
  flex-direction: column;
  margin: auto;
}
.other-box-r-box-li-t {
  width: 33px;
  height: 33px;
  margin: 0 auto;
}
.other-box-r-box-li-t > img {
  width: 100%;
  height: 100%;
}
.other-box-r-box-li-b {
  height: calc(100% - 43px);
  margin-top: 5px;
  font-size: 0.8rem;
  text-align: center;
  color: #504949;
}
</style>
